import React, { useCallback, useEffect, useState } from 'react';
import AdminPanelPage from './AdminPanelPage';
import AdminLoginPage from './AdminLoginPage';
import { ADMIN_SESSION_ENDED_EVENT, hasAdminSession, loginCameWithoutToken } from './adminAuth';

const AdminGatePage = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(() => hasAdminSession());
    const [notice, setNotice] = useState('');

    const handleLoginSuccess = useCallback(() => {
        setNotice('');
        setIsAuthenticated(true);
    }, []);

    // The API refused the session's token (adminApi.js): back to the login.
    useEffect(() => {
        const onEnded = () => {
            setNotice(loginCameWithoutToken()
                ? 'The API refused the panel: the login sent no admin token. Is the latest backend running, with ADMIN_API_TOKEN set?'
                : 'Your session has ended. Sign in again.');
            setIsAuthenticated(false);
        };
        window.addEventListener(ADMIN_SESSION_ENDED_EVENT, onEnded);
        return () => window.removeEventListener(ADMIN_SESSION_ENDED_EVENT, onEnded);
    }, []);

    if (!isAuthenticated) {
        return <AdminLoginPage onSuccess={handleLoginSuccess} notice={notice} />;
    }

    return <AdminPanelPage />;
};

export default AdminGatePage;
